import { LotsPage } from './pages/Lots';
import { designLink, isDemo, isEmbedded, isPreview, isResponsive } from './preview';
import './responsive.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

function App() {
  const layoutClasses = [
    isResponsive ? 'responsive-design' : null,
    isEmbedded ? 'embedded-view' : null,
  ].filter(Boolean).join(' ');

  return (
    <div className={layoutClasses || undefined}>
      {isPreview && (
        <nav className="preview-toolbar" aria-label="Вариант оформления">
          <span>Локальный просмотр · {isDemo ? 'демоданные' : 'локальный API'}</span>
          <a href={designLink('responsive')} aria-current={isResponsive ? 'page' : undefined}>Адаптивный</a>
          <a href={designLink('classic')} aria-current={!isResponsive ? 'page' : undefined}>Прежний</a>
        </nav>
      )}
      <LotsPage />
    </div>
  );
}

export default App;
